<button
  type="button"
  role="switch"
  tabindex="0"
  class="button"
  [ngClass]="{
    'button--special': config.style === 'button' && config.level === 'special',
    'button--high': config.style === 'button' && config.level === 'high',
    'button--medium':
      config.style === 'button' && (config.level === 'medium' || !config.level),
    'button--low': config.style === 'button' && config.level === 'low',
    'button--text': config.style === 'button' && config.level === 'text',
    'button--toggle': config.style === 'toggle' || !config.style,
    'is-active': isSelected,
    'u-maxX': config.size === 'fullWidth',
  }"
  [attr.aria-checked]="isSelected"
  [attr.aria-label]="getApplicableConfig()?.content"
  (click)="onClick()"
  (keydown.enter)="onClick()"
>
  @if (getApplicableConfig(); as applicableConfig) {
    <div class="button__content">
      @if (applicableConfig.icon) {
        <icon
          class="button__icon"
          [name]="applicableConfig.icon"
          [config]="{ fill: getIconFill() }"
        >
        </icon>
      }
      <span>{{ applicableConfig.content }}</span>
    </div>
  }
</button>
